import { useInfiniteQuery } from 'react-query'

import { useAuthentication } from '@hooks/useAuthentication'
import { NewestParam } from '@models/newest/NewestParam'
import { useNewestAction } from './useNewestAction'

export function useGetNewBooks(params: NewestParam) {
  const newestClient = useNewestAction()
  const { canFetchApi } = useAuthentication()

  const { fetchNextPage, data, isLoading, isFetchingNextPage } =
    useInfiniteQuery(
      ['get_newest', params],
      async ({ pageParam = 1 }) => {
        return newestClient.getNewBooks({
          ...params,
          page: pageParam,
        })
      },
      {
        enabled: canFetchApi,
        getNextPageParam: lastPage => {
          if (
            lastPage &&
            lastPage.page * params.limitPerPage < lastPage.total &&
            lastPage.page * params.limitPerPage < 200
          )
            return lastPage.page + 1

          return undefined
        },
      }
    )

  function handleFetchNextPage() {
    if (!isFetchingNextPage) fetchNextPage()
  }

  return {
    data,
    isLoading,
    handleFetchNextPage,
  }
}
